import React, { Component } from "react";
import { connect } from "react-redux";
import { updateWinchSelection, validateWinchType } from "../actions/";

class WinchSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      winchType: [],
      validWinch: true
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.validWinch !== this.props.validWinch) {
      if (!this.props.validWinch) {
        this.setState({
          validWinch: false
        });
      } else {
        this.setState({
          validWinch: true
        });
      }
    }
    if (
      prevProps.mType !== this.props.mType ||
      (this.props.motorType &&
        this.props.motorType.orderCode !== prevProps.motorType.orderCode) ||
      this.props.previewStatus !== prevProps.previewStatus
    ) {
      if (this.props.mType === "metric" && !this.props.motorType) {
        this.setState({
          winchType: [
            {
              name: "TITAN TI 1",
              orderCode: "01",
              hoistingForce: "12,5 kN",
              ropeSpeed: "40 m/min",
              img: "../images/T1.png"
            },
            {
              name: "TITAN TI 2",
              orderCode: "02",
              hoistingForce: "26 kN",
              ropeSpeed: "42 m/min",
              img: "../images/T2.png"
            },
            {
              name: "TITAN TI 4",
              orderCode: "04",
              hoistingForce: "45 kN",
              ropeSpeed: "47 m/min",
              img: "../images/T4GEAR.png"
            },
            {
              name: "TITAN TI 5",
              orderCode: "05",
              hoistingForce: "55 kN",
              ropeSpeed: "46 m/min",
              img: "../images/T5.png"
            }
          ]
        });
      } else if (this.props.mType === "imperial" && !this.props.motorType) {
        this.setState({
          winchType: [
            {
              name: "TITAN TI 1",
              orderCode: "01",
              hoistingForce: "2850 lbf",
              ropeSpeed: "137 ft/min",
              img: "../images/T1.png"
            },
            {
              name: "TITAN TI 2",
              orderCode: "02",
              hoistingForce: "5900 lbf",
              ropeSpeed: "139 ft/min",
              img: "../images/T2.png"
            },
            {
              name: "TITAN TI 4",
              orderCode: "04",
              hoistingForce: "10100 lbf",
              ropeSpeed: "155 ft/min",
              img: "../images/T4GEAR.png"
            },
            {
              name: "TITAN TI 5",
              orderCode: "05",
              hoistingForce: "12300 lbf",
              ropeSpeed: "152 ft/min",
              img: "../images/T5.png"
            }
          ]
        });
      }
      if (
        this.props.motorType.orderCode === "PM049" &&
        this.props.winchType.orderCode === "04" &&
        this.props.mType === "imperial"
      ) {
        this.setState({
          winchType: [
            {
              name: "TITAN TI 1",
              orderCode: "01",
              hoistingForce: "2850 lbf",
              ropeSpeed: "137 ft/min",
              img: "../images/T1.png"
            },
            {
              name: "TITAN TI 2",
              orderCode: "02",
              hoistingForce: "5900 lbf",
              ropeSpeed: "139 ft/min",
              img: "../images/T2.png"
            },
            {
              name: "TITAN TI 4",
              orderCode: "04",
              hoistingForce: "10100 lbf",
              ropeSpeed: "155 ft/min",
              img: "../images/T4PISTON.png"
            },
            {
              name: "TITAN TI 5",
              orderCode: "05",
              hoistingForce: "12300 lbf",
              ropeSpeed: "152 ft/min",
              img: "../images/T5.png"
            }
          ]
        });
        this.props.onWinchSelect({
          name: "TITAN TI 4",
          orderCode: "04",
          hoistingForce: "10100 lbf",
          ropeSpeed: "155 ft/min",
          img: "../images/T4PISTON.png"
        });
      } else if (
        this.props.motorType.orderCode === "PM049" &&
        this.props.winchType.orderCode === "04" &&
        this.props.mType === "metric"
      ) {
        this.setState({
          winchType: [
            {
              name: "TITAN TI 1",
              orderCode: "01",
              hoistingForce: "12,5 kN",
              ropeSpeed: "40 m/min",
              img: "../images/T1.png"
            },
            {
              name: "TITAN TI 2",
              orderCode: "02",
              hoistingForce: "26 kN",
              ropeSpeed: "42 m/min",
              img: "../images/T2.png"
            },
            {
              name: "TITAN TI 4",
              orderCode: "04",
              hoistingForce: "45 kN",
              ropeSpeed: "47 m/min",
              img: "../images/T4PISTON.png"
            },
            {
              name: "TITAN TI 5",
              orderCode: "05",
              hoistingForce: "55 kN",
              ropeSpeed: "46 m/min",
              img: "../images/T5.png"
            }
          ]
        });
        this.props.onWinchSelect({
          name: "TITAN TI 4",
          orderCode: "04",
          hoistingForce: "45,0 kN",
          ropeSpeed: "47 m/min",
          img: "../images/T4PISTON.png"
        });
      } else if (this.props.motorType && this.props.mType === "metric") {
        this.setState({
          winchType: [
            {
              name: "TITAN TI 1",
              orderCode: "01",
              hoistingForce: "12,5 kN",
              ropeSpeed: "40 m/min",
              img: "../images/T1.png"
            },
            {
              name: "TITAN TI 2",
              orderCode: "02",
              hoistingForce: "26 kN",
              ropeSpeed: "42 m/min",
              img: "../images/T2.png"
            },
            {
              name: "TITAN TI 4",
              orderCode: "04",
              hoistingForce: "45 kN",
              ropeSpeed: "47 m/min",
              img: "../images/T4GEAR.png"
            },
            {
              name: "TITAN TI 5",
              orderCode: "05",
              hoistingForce: "55,0 kN",
              ropeSpeed: "46 m/min",
              img: "../images/T5.png"
            }
          ]
        });
      } else if (this.props.motorType && this.props.mType === "imperial") {
        this.setState({
          winchType: [
            {
              name: "TITAN TI 1",
              orderCode: "01",
              hoistingForce: "2850 lbf",
              ropeSpeed: "137 ft/min",
              img: "../images/T1.png"
            },
            {
              name: "TITAN TI 2",
              orderCode: "02",
              hoistingForce: "5900 lbf",
              ropeSpeed: "139 ft/min",
              img: "../images/T2.png"
            },
            {
              name: "TITAN TI 4",
              orderCode: "04",
              hoistingForce: "10100 lbf",
              ropeSpeed: "155 ft/min",
              img: "../images/T4GEAR.png"
            },
            {
              name: "TITAN TI 5",
              orderCode: "05",
              hoistingForce: "12300 lbf",
              ropeSpeed: "152 ft/min",
              img: "../images/T5.png"
            }
          ]
        });
      }
    }
  }
  storeWinchSelection = selectedOption => {
    this.props.onWinchSelect(selectedOption);
    this.props.validateWinchType(true);
  };

  render() {
    var winches = this.state.winchType.map((winch, index) => {
      return (
        <Winch
          winchType={winch}
          key={index}
          currentlySelected={this.props.winchType}
          selected={this.props.winchType.name === winch.name}
          onWinchClick={winchType => {
            this.storeWinchSelection(winchType);
          }}
        />
      );
    });

    return (
      <div className="winch_section">
        {this.props.refresh && (
          <div>
            <p className="field_heading">Select your winch</p>
            {this.state.validWinch === false && (
              <p className="warning">Please select a winch.</p>
            )}
            <div className="winch_group row">{winches}</div>
          </div>
        )}
      </div>
    );
  }
}

class Winch extends Component {
  handleClick = () => {
    var elems = document.querySelectorAll(".winch");

    [].forEach.call(elems, function(el) {
      el.classList.remove("selected");
    });
    document.getElementById("winch_" + this.props.winchType.name).className +=
      " selected";
    this.props.onWinchClick(this.props.winchType);
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.winchType !== prevProps.winchType &&
      this.props.currentlySelected.orderCode
    ) {
      if (
        this.props.winchType.orderCode ===
        this.props.currentlySelected.orderCode
      )
        this.props.onWinchClick(this.props.winchType);
    }
  }

  render() {
    return (
      <div
        className={
          "winch col-md-3 col-sm-2 col-xs-12 " +
          (this.props.selected ? "selected" : "")
        }
        onClick={this.handleClick}
        id={"winch_" + this.props.winchType.name}
      >
        <div className="flex winch_top field-top">
          <div>
            <strong>{this.props.winchType.name}</strong>
          </div>
           
        </div>
        <div className="winch_body">
          <img
            className="winch_img"
            src={this.props.winchType.img}
            alt={"winch" + this.props.winchType.name}
          />
          {/* <div className="row unselected">
            <div className="col-md-4">Type:</div>
            <div className="col-md-8 winch_desc">
              TITAN {this.props.winchType.hoistingForce}, <br />
              {this.props.winchType.ropeSpeed}
            </div>
          </div> */}
          <div className="row onselect">
            <div className="col-md-4">Type:</div>
            <div className="col-md-8 winch_desc">
              {this.props.winchType.name}
              <br />
              {this.props.winchType.hoistingForce} hoisting force, <br />{" "}
              {this.props.winchType.ropeSpeed} rope speed
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mType: state.mType,
    motorType: state.motorType,
    winchType: state.winchType,
    previewHtml: state.previewHtml,
    previewStatus: state.previewStatus,
    validWinch: state.validWinch
  };
};

const mapActionsToProps = {
  onWinchSelect: updateWinchSelection,
  validateWinchType: validateWinchType
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(WinchSelection);



// WEBPACK FOOTER //
// ./src/components/winchSelection.js